import authReducer from "@funded-here-interface/common/src/features/auth/authSlice_Admin";
import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import storageSession from "redux-persist/lib/storage/session";

import BorbankSlice from "./features/merchant/bankSlice";
import bizBorSlice from "./features/merchant/biz";
import docBorrowerSlice from "./features/merchant/doc";
import BorrepSlice from "./features/merchant/rep";
import bankSlice from "./features/registration/bankSlice";
import bizSlice from "./features/registration/bizSlice";
import docSlice from "./features/registration/docSlice";
import repSlice from "./features/registration/repSlice";
import bulkSlice from "./features/sku/bulkSlice";

// One-time migration: clear orphaned localStorage persist key
// (admin switched from localStorage to sessionStorage for persistence)
if (localStorage.getItem("persist:root")) {
  localStorage.removeItem("persist:root");
}

const persistConfig = {
  key: "root",
  storage: storageSession,
  whitelist: ["auth"], // Add other reducers you want to persist here
};
const persistedReducer = persistReducer(
  persistConfig,
  combineReducers({
    auth: authReducer,
    biz: bizSlice,
    rep: repSlice,
    bank: bankSlice,
    doc: docSlice,
    bulk: bulkSlice,
    borBiz: bizBorSlice,
    BorBank: BorbankSlice,
    Borrep: BorrepSlice,
    bordoc: docBorrowerSlice,
  }),
);

const store = configureStore({
  reducer: persistedReducer,
});

const persistor = persistStore(store);

export { store, persistor };
export type RootState = ReturnType<typeof store.getState>;
